// extracted by mini-css-extract-plugin
export default {"content":"EditProfilePage_content__VzD8V","wrapper":"EditProfilePage_wrapper__sR239"};